// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================
   Remix Video Modal
   ====================== */

.remix-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(4px);
}

.remix-modal {
  position: relative;
  display: flex;
  width: min(960px, 100%);
  max-height: min(680px, calc(100vh - 48px));
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 10px;
  overflow: hidden;
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  color: var(--color-text-primary);
}

.remix-modal__close {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-secondary);
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.remix-modal__close:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

/* Preview side */

.remix-modal__preview {
  flex: 1.1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  background: #000;
  padding: 16px;
}

.remix-modal__video {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  border-radius: 6px;
  background: #000;
}

/* Panel side */

.remix-modal__panel {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
  padding: 24px;
  overflow-y: auto;
}

.remix-modal__heading {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-right: 28px;
}

.remix-modal__title {
  margin: 0;
  font-size: 20px;
  font-weight: 500;
  font-family: 'Geist Sans', 'Times New Roman', serif;
}

.remix-modal__subtitle {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.45;
  color: var(--color-text-secondary);
}

.remix-modal__source {
  padding: 8px 10px;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: var(--color-bg-input);
}

.remix-modal__source-label {
  display: block;
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--color-text-secondary);
  margin-bottom: 3px;
}

.remix-modal__source-prompt {
  margin: 0;
  font-size: 12px;
  line-height: 1.4;
  color: var(--color-text-secondary);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.remix-modal__textarea {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: var(--color-bg-input);
  font-size: 13px;
  line-height: 1.5;
  color: var(--color-text-primary);
  font-family: inherit;
  resize: vertical;
  min-height: 88px;
  transition: border-color 0.15s ease;
}

.remix-modal__textarea:focus {
  outline: none;
  border-color: var(--color-accent-base);
  box-shadow: 0 0 0 3px var(--color-focus-ring);
}

.remix-modal__textarea::placeholder {
  color: var(--color-text-secondary);
}

/* Attachments */

.remix-modal__attachments {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.remix-modal__attachment {
  position: relative;
  width: 56px;
  height: 56px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid var(--color-border-input);
}

.remix-modal__attachment img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.remix-modal__attachment-remove {
  position: absolute;
  top: 3px;
  right: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: none;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  cursor: pointer;
}

/* Controls row */

.remix-modal__controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.remix-modal__attach-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 10px;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: transparent;
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
  white-space: nowrap;
}

.remix-modal__attach-button:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
  color: var(--color-text-primary);
}

.remix-modal__attach-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Model selector */

.remix-modal__model-trigger {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
  padding: 7px 10px;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: border-color 0.15s ease;
}

.remix-modal__model-trigger:hover:not(:disabled) {
  border-color: var(--color-text-secondary);
}

.remix-modal__model-thumb {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  object-fit: contain;
  flex-shrink: 0;
}

.remix-modal__model-label {
  max-width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.remix-modal__model-menu {
  z-index: 2100;
  min-width: 260px;
  max-height: 320px;
  overflow-y: auto;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  padding: 4px;
  box-shadow: 0 12px 32px -16px rgba(0, 0, 0, 0.45);
}

.remix-modal__model-item {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 8px 10px;
  border-radius: 4px;
  cursor: pointer;
  outline: none;
  transition: background 0.12s ease;
}

.remix-modal__model-item:hover,
.remix-modal__model-item:focus {
  background: var(--color-bg-user-bubble);
}

.remix-modal__model-item--disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.remix-modal__model-item-copy {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
  flex: 1 1;
}

.remix-modal__model-item-label {
  font-size: 12.5px;
  font-weight: 500;
  color: var(--color-text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.remix-modal__model-item-desc {
  font-size: 10.5px;
  color: var(--color-text-secondary);
}

.remix-modal__model-check {
  color: var(--color-accent-base);
  flex-shrink: 0;
}

.remix-modal__model-empty {
  padding: 12px;
  font-size: 12px;
  color: var(--color-text-secondary);
  text-align: center;
}

.remix-modal__hint {
  margin: 0;
  font-size: 11.5px;
  color: var(--color-accent-base);
}

.remix-modal__error {
  padding: 8px 10px;
  border-radius: 6px;
  background: var(--color-status-error-tint);
  border: 1px solid var(--color-status-error-border);
  color: var(--color-status-error-text);
  font-size: 12px;
}

/* Footer */

.remix-modal__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: auto;
  padding-top: 8px;
}

.remix-modal__project-link {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 0;
  border: none;
  background: transparent;
  color: var(--color-text-secondary);
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  transition: color 0.15s ease;
}

.remix-modal__project-link:hover {
  color: var(--color-text-primary);
}

.remix-modal__submit {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 9px 18px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: var(--color-accent-base);
  color: var(--color-text-on-accent);
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s ease;
}

.remix-modal__submit:hover:not(:disabled) {
  background: var(--color-accent-strong);
}

.remix-modal__submit:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.remix-modal__submit-spinner {
  animation: remix-spin 1s linear infinite;
}

@keyframes remix-spin {
  to {
    transform: rotate(360deg);
  }
}

/* Responsive: stack on small screens */

@media (max-width: 760px) {
  .remix-modal {
    flex-direction: column;
    max-height: calc(100vh - 32px);
    overflow-y: auto;
  }

  .remix-modal__preview {
    flex: none;
    max-height: 40vh;
  }

  .remix-modal__panel {
    flex: none;
  }
}
.remix-modal__keep-audio {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--color-text-secondary);
  font-size: 13px;
  cursor: pointer;
}

.remix-modal__keep-audio input {
  width: 15px;
  height: 15px;
  accent-color: var(--color-text-primary);
}
`, "",{"version":3,"sources":["webpack://./src/components/RemixVideoModal.css"],"names":[],"mappings":"AAAA;;2BAE2B;;AAE3B;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,0CAA0C;EAC1C,0CAA0C;EAC1C,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,8EAA8E;EAC9E,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;EAC1C,kCAAkC;EAClC,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA,iBAAiB;;AAEjB;EACE,WAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,eAAe;;AAEf;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;AACpC;;AAEA,gBAAgB;;AAEhB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,eAAe;AACjB;;AAEA,iBAAiB;;AAEjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mBAAmB;;AAEnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;EAC1C,2CAA2C;EAC3C,kBAAkB;EAClB,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,iCAAiC;AACnC;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,kDAAkD;EAClD,qCAAqC;EACrC,eAAe;AACjB;;AAEA,WAAW;;AAEX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,oCAAoC;EACpC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,uCAAuC;;AAEvC;EACE;IACE,sBAAsB;IACtB,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;AACF;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kCAAkC;EAClC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;AACzC","sourcesContent":["/* ======================\n   Remix Video Modal\n   ====================== */\n\n.remix-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(4px);\n}\n\n.remix-modal {\n  position: relative;\n  display: flex;\n  width: min(960px, 100%);\n  max-height: min(680px, calc(100vh - 48px));\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 10px;\n  overflow: hidden;\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  color: var(--color-text-primary);\n}\n\n.remix-modal__close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.remix-modal__close:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n/* Preview side */\n\n.remix-modal__preview {\n  flex: 1.1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 0;\n  background: #000;\n  padding: 16px;\n}\n\n.remix-modal__video {\n  max-width: 100%;\n  max-height: 100%;\n  width: auto;\n  height: auto;\n  border-radius: 6px;\n  background: #000;\n}\n\n/* Panel side */\n\n.remix-modal__panel {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-width: 0;\n  padding: 24px;\n  overflow-y: auto;\n}\n\n.remix-modal__heading {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding-right: 28px;\n}\n\n.remix-modal__title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 500;\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n}\n\n.remix-modal__subtitle {\n  margin: 0;\n  font-size: 12.5px;\n  line-height: 1.45;\n  color: var(--color-text-secondary);\n}\n\n.remix-modal__source {\n  padding: 8px 10px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: var(--color-bg-input);\n}\n\n.remix-modal__source-label {\n  display: block;\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--color-text-secondary);\n  margin-bottom: 3px;\n}\n\n.remix-modal__source-prompt {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.4;\n  color: var(--color-text-secondary);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.remix-modal__textarea {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 10px 12px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: var(--color-bg-input);\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--color-text-primary);\n  font-family: inherit;\n  resize: vertical;\n  min-height: 88px;\n  transition: border-color 0.15s ease;\n}\n\n.remix-modal__textarea:focus {\n  outline: none;\n  border-color: var(--color-accent-base);\n  box-shadow: 0 0 0 3px var(--color-focus-ring);\n}\n\n.remix-modal__textarea::placeholder {\n  color: var(--color-text-secondary);\n}\n\n/* Attachments */\n\n.remix-modal__attachments {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.remix-modal__attachment {\n  position: relative;\n  width: 56px;\n  height: 56px;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 1px solid var(--color-border-input);\n}\n\n.remix-modal__attachment img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.remix-modal__attachment-remove {\n  position: absolute;\n  top: 3px;\n  right: 3px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  border: none;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.65);\n  color: #fff;\n  cursor: pointer;\n}\n\n/* Controls row */\n\n.remix-modal__controls {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.remix-modal__attach-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 10px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n  white-space: nowrap;\n}\n\n.remix-modal__attach-button:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n  color: var(--color-text-primary);\n}\n\n.remix-modal__attach-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Model selector */\n\n.remix-modal__model-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  min-width: 0;\n  padding: 7px 10px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: border-color 0.15s ease;\n}\n\n.remix-modal__model-trigger:hover:not(:disabled) {\n  border-color: var(--color-text-secondary);\n}\n\n.remix-modal__model-thumb {\n  width: 16px;\n  height: 16px;\n  border-radius: 3px;\n  object-fit: contain;\n  flex-shrink: 0;\n}\n\n.remix-modal__model-label {\n  max-width: 170px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.remix-modal__model-menu {\n  z-index: 2100;\n  min-width: 260px;\n  max-height: 320px;\n  overflow-y: auto;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  padding: 4px;\n  box-shadow: 0 12px 32px -16px rgba(0, 0, 0, 0.45);\n}\n\n.remix-modal__model-item {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  padding: 8px 10px;\n  border-radius: 4px;\n  cursor: pointer;\n  outline: none;\n  transition: background 0.12s ease;\n}\n\n.remix-modal__model-item:hover,\n.remix-modal__model-item:focus {\n  background: var(--color-bg-user-bubble);\n}\n\n.remix-modal__model-item--disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.remix-modal__model-item-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  min-width: 0;\n  flex: 1;\n}\n\n.remix-modal__model-item-label {\n  font-size: 12.5px;\n  font-weight: 500;\n  color: var(--color-text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.remix-modal__model-item-desc {\n  font-size: 10.5px;\n  color: var(--color-text-secondary);\n}\n\n.remix-modal__model-check {\n  color: var(--color-accent-base);\n  flex-shrink: 0;\n}\n\n.remix-modal__model-empty {\n  padding: 12px;\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  text-align: center;\n}\n\n.remix-modal__hint {\n  margin: 0;\n  font-size: 11.5px;\n  color: var(--color-accent-base);\n}\n\n.remix-modal__error {\n  padding: 8px 10px;\n  border-radius: 6px;\n  background: var(--color-status-error-tint);\n  border: 1px solid var(--color-status-error-border);\n  color: var(--color-status-error-text);\n  font-size: 12px;\n}\n\n/* Footer */\n\n.remix-modal__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: auto;\n  padding-top: 8px;\n}\n\n.remix-modal__project-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 6px 0;\n  border: none;\n  background: transparent;\n  color: var(--color-text-secondary);\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  transition: color 0.15s ease;\n}\n\n.remix-modal__project-link:hover {\n  color: var(--color-text-primary);\n}\n\n.remix-modal__submit {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 9px 18px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: var(--color-accent-base);\n  color: var(--color-text-on-accent);\n  font-size: 13px;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.remix-modal__submit:hover:not(:disabled) {\n  background: var(--color-accent-strong);\n}\n\n.remix-modal__submit:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.remix-modal__submit-spinner {\n  animation: remix-spin 1s linear infinite;\n}\n\n@keyframes remix-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Responsive: stack on small screens */\n\n@media (max-width: 760px) {\n  .remix-modal {\n    flex-direction: column;\n    max-height: calc(100vh - 32px);\n    overflow-y: auto;\n  }\n\n  .remix-modal__preview {\n    flex: none;\n    max-height: 40vh;\n  }\n\n  .remix-modal__panel {\n    flex: none;\n  }\n}\n.remix-modal__keep-audio {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--color-text-secondary);\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.remix-modal__keep-audio input {\n  width: 15px;\n  height: 15px;\n  accent-color: var(--color-text-primary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
